import src from "IMAGE";
export default { src, width: 66, height: 66, blurWidth: 0, blurHeight: 0};
